





// TS
export interface MonoState {
   data: any;
   loading: boolean;
   error: null | string;
  
}

export enum MonoActionTypes {
   FETCH_MONO = 'FETCH_MONO',
   FETCH_MONO_SUCCESS = 'FETCH_MONO_SUCCESS',
   FETCH_MONO_ERROR = 'FETCH_MONO_ERROR',
}

interface FetchMonoAction {
   type: MonoActionTypes.FETCH_MONO;
}

interface FetchMonoSuccessAction {
   type: MonoActionTypes.FETCH_MONO_SUCCESS;
   payload: any
}

interface FetchMonoErrorAction {
   type: MonoActionTypes.FETCH_MONO_ERROR;
   payload: string;
}

export type MonoAction = FetchMonoAction | FetchMonoSuccessAction | FetchMonoErrorAction 
